<template>
  <div class="login-wrapper">
    <div class="banner" v-if="hasType">
      <img :src="store.getters.banner" />
    </div>
    <div class="login-container">
      <h2 :class="{ 'banner-title': hasType }">成绩查询平台</h2>
      <div @click="selectTestClick" v-if="!hasType" class="select-test">
        {{ testName }}
        <span class="iconfont test-icon">&#xe6b7;</span>
      </div>

      <van-field
        class="file-account"
        v-model="account"
        :placeholder="hasType ? '请输入考生姓名' : '请输入报名网站账号'"
      />
      <van-field
        class="file-account"
        v-if="hasType"
        v-model="idNumber"
        placeholder="请输入考生身份证号码"
      />
      <van-field
        v-if="!hasType"
        class="file-pass"
        type="password"
        v-model="password"
        placeholder="请输入个人报名网站密码"
      />
      <div v-show="errorContent.length > 0" class="error">
        {{ errorContent }}
      </div>
      <div id="captcha-button"></div>
      <div id="captcha-element"></div>
      <van-button
        :style="{ opacity: opacityValue }"
        class="login"
        type="primary"
        size="large"
        @click="opacityValue === 1 && loginClick()"
        >登录</van-button
      >
    </div>
    <div class="bottom">
      <img :src="store.getters.logo" alt="ata" />
    </div>
  </div>
  <login-select-test
    ref="selectTest"
    :testArray="testArray"
    :defaultIndex="defaultIndex"
    @change-testName="changeTestName"
  ></login-select-test>
</template>

<script>
import cookie from "js-cookie";
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { getAllTestFiles, login, getEncryptedSceneId } from "../../api/index";
import LoginSelectTest from "./components/loginSelectTest.vue";
import { setTheme } from "../../utils/theme.js";
import { CODE_BEIKE_1, CODE_BEIKE_2, CODE_BEIKE_3 } from "@/utils/constant";

export default {
  name: "Login",
  components: { LoginSelectTest },
  setup() {
    function IsPC() {
      let userAgentInfo = navigator.userAgent;
      let Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
    if (IsPC()) {
      window.location = location.href.replace("/login", "/web/login");
    }
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const route = useRoute();
    if (isIOS) {
      window.history.pushState({}, "title", location.hash);
    }
    const hasType = ref(route.query.type != null);
    setTheme(hasType.value ? "blue" : "red");
    // 定义router
    const router = useRouter();
    // 定义store
    const store = useStore();
    /** 选择考试 */
    // 获取全部考试项目
    // 定义选择后考试的code
    let testCode = ref(route.query.type || "");
    // 定义考试数组
    const testArray = ref([]);
    const defaultIndex = ref(0);
    store.commit("saveTestCode", route.query.type || "");

    const getAllFiles = async () => {
      const { data } = await getAllTestFiles();
      if (hasType.value) {
        data.forEach((item, index) => {
          if (item.code === route.query.type) {
            testCode.value = item.code;
            selectedAuthType.value = item.authType;
            defaultIndex.value = index;
            testName.value = item.name;
          }
        });
      }
      testArray.value = data.sort((a, b) => a.order - b.order);
    };
    // 选择的考试科目名
    const testName = ref("请选择考试");
    const selectedAuthType = ref("");
    // 子组件
    const selectTest = ref(null);
    // 当子组件选择完考试将考试内容框更新
    const changeTestName = (value) => {
      testName.value = value;
      testArray.value.forEach((item) => {
        if (item.name === value) {
          testCode.value = item.code;
          selectedAuthType.value = item.authType;
          hasType.value =
            item.code === CODE_BEIKE_1 ||
            item.code === CODE_BEIKE_2 ||
            item.code === CODE_BEIKE_3;
        }
      });
    };
    // 点击选择考试打开子组件弹出框
    const selectTestClick = () => {
      if (hasType.value) return;
      if (!selectTest.value.show) {
        selectTest.value.show = true;
      }
    };

    /** 登录  */
    const captcha = ref(null);
    const captchaButton = ref(null);
    // 获取后端加密后的 SceneId
    const getEncryptedSceneIdFn = async () => {
      const { data } = await getEncryptedSceneId();
      return data;
    };
    // 滑块验证的信息
    const slideInformation = ref({
      captchaVerifyParam: "",
      sceneId: "",
    });
    // 按钮的透明度
    const opacityValue = ref(0.5);
    // 错误提示内容
    const errorContent = ref("");
    // 用户账号
    const account = ref("");
    // 用户身份证号
    const idNumber = ref("");
    // 用户密码
    const password = ref("");
    // 初始化滑动加载
    const init = async () => {
      const { encryptedSceneId, sceneId } = await getEncryptedSceneIdFn();
      window.initAliyunCaptcha({
        SceneId: sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        EncryptedSceneId: encryptedSceneId, // 加密字符串
        mode: "embed", // 弹出式 popup  嵌入式 embed
        element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#captcha-button", // 触发验证码弹窗的元素。
        success: (data) => {
          opacityValue.value = 1;
          slideInformation.value.captchaVerifyParam = data;
          slideInformation.value.sceneId = sceneId;
        },
        // 验证码验证不通过回调函数
        fail: (result) => {
          console.error(result);
        },
        getInstance: (instance) => {
          captcha.value = instance;
        }, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 320,
          height: 36,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    };
    // 登录
    const loginClick = async () => {
      if (testName.value === "请选择考试" && !hasType.value) {
        errorContent.value = "请先选择考试，再进行登录";
        return;
      }
      if (hasType.value && (!account.value || !idNumber.value)) {
        return (errorContent.value = "身份证和姓名不能为空");
      }
      if (!hasType.value && (!account.value || !password.value)) {
        errorContent.value = "账号或密码不能为空";
        return;
      }
      errorContent.value = "";
      store.commit("setProjectCode", testCode.value);

      // 调登录接口失败在给错误提示
      const { data, message } = await login({
        projectCode: testCode.value,
        loginName: account.value,
        loginPwd: password.value,
        idNumber: idNumber.value,
        captchaV2: slideInformation.value,
      });
      if (!data) {
        errorContent.value = message;
      } else {
        const { credentialsID, projectName } = data;
        store.commit("saveCredentialsID", credentialsID);
        store.commit("saveProjectName", projectName);
        store.commit("saveAuthType", selectedAuthType.value);
        router.push(`/home/${testCode.value}`);
      }
    };
    onMounted(() => {
      cookie.remove("data");
      captchaButton.value = document.getElementById("#captcha-button");
      init();
      // 获取全部考试项目
      getAllFiles();
      let slide = document.getElementById("nc_1_nocaptcha");
      if (slide) {
        slide.remove();
      }
    });
    return {
      opacityValue,
      account,
      password,
      selectTest,
      selectTestClick,
      changeTestName,
      testName,
      errorContent,
      loginClick,
      testArray,
      hasType,
      defaultIndex,
      idNumber,
      store,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
@import "scss/color.scss";
.login-wrapper {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.banner {
  // height: 360px;
  width: 100%;
  img {
    object-fit: cover;
    // height: 360px;
    width: 100%;
  }
}
.login-container :deep(.van-cell) {
  border-bottom: 1px solid #ddd;
}
.login-container :deep(.van-field__control) {
  font-size: 30px;
}
.login-container :deep(.sm-pop-inner) {
  position: relative !important;
}
.login-container :deep(.nc_wrapper) {
  width: 100% !important;
}
// .login-container :deep(.nc-container .nc_wrapper .errloading) {
//   height: 40px !important;
//   box-sizing: border-box;
// }
// .login-container :deep(.nc_scale) {
//   height: 80px;
// }
// .login-container :deep(.nc-container .nc_scale span) {
//   height: 76px;
// }
// .login-container :deep(.nc-container .nc_scale span) {
//   line-height: 80px !important;
// }
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 65px 60px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  h2 {
    font-weight: bold;
    margin-top: 30px;
    letter-spacing: 2px;
  }
  .banner-title {
    margin-top: 0;
  }
  .select-test {
    @include flex-center;
    padding: 0 30px;
    height: 74px;
    border: 3px solid var(--primary-color);
    color: var(--primary-color);
    border-radius: 40px;
    font-size: 30px;
    margin-top: 84px;
    .test-icon {
      font-size: 26px;
      margin-left: 10px;
    }
  }
  .file-account {
    margin-top: 60px;
  }
  .file-pass {
    margin-top: 20px;
  }
  .error {
    font-size: 28px;
    color: #f63132;
    margin: 30px 0;
    width: 100%;
    padding-left: 2px;
  }
  #captcha-element {
    margin-top: 30px;
    z-index: 0 !important;
  }
  .login {
    margin-top: 30px;
    border-radius: 60px;
    height: 90px;
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }
}
.bottom {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  color: $color-gray;
  img {
    height: 54px;
  }
}
.login-container :deep(::-webkit-input-placeholder) {
  /* WebKit browsers */
  color: $color-gray;
  font-size: 30px;
}

.login-container :deep(::-moz-placeholder) {
  /* Mozilla Firefox 19+ */
  color: $color-gray;
  font-size: 30px;
}

.login-container :deep(:-ms-input-placeholder) {
  /* Internet Explorer 10+ */
  color: $color-gray;
  font-size: 30px;
}
</style>
